import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Fab, Tooltip } from '@mui/material';
import { Suspense, lazy, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// The panel pulls in the markdown renderer; keep it out of the main bundle
// since the FAB is mounted on every page.
const HelpPanel = lazy(() =>
    import('./HelpPanel').then(m => ({ default: m.HelpPanel }))
);

export const HelpFab = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [open, setOpen] = useState(false);
    const [mounted, setMounted] = useState(false);
    const [tab, setTab] = useState(0);

    useEffect(() => {
        if (searchParams.get('help') !== 'tickets') return;
        setMounted(true);
        setOpen(true);
        setTab(1);
        const next = new URLSearchParams(searchParams);
        next.delete('help');
        setSearchParams(next, { replace: true });
    }, [searchParams, setSearchParams]);

    return (
        <>
            <Tooltip title="Help">
                <Fab
                    color="primary"
                    aria-label="Open help"
                    onClick={() => {
                        setMounted(true);
                        setOpen(true);
                    }}
                    sx={{
                        position: 'fixed',
                        right: 20,
                        // CreateButton FAB (below md): bottom 60 + 64 touch size + 16 gap.
                        // ponytail: always lift on <md even when there is no create FAB
                        // (projects list, no create permission). Extra empty corner.
                        bottom: { xs: 140, md: 24 },
                        // Above MUI Dialog backdrops (modal 1300) so help stays clickable.
                        zIndex: theme => theme.zIndex.modal + 1,
                    }}
                >
                    <HelpOutlineIcon />
                </Fab>
            </Tooltip>
            {mounted ? (
                <Suspense fallback={null}>
                    <HelpPanel
                        open={open}
                        onClose={() => setOpen(false)}
                        tab={tab}
                        onTabChange={setTab}
                    />
                </Suspense>
            ) : null}
        </>
    );
};

export default HelpFab;
